import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@mui/styles';
import clsx from 'clsx';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Check from '@mui/icons-material/Check';
import SettingsIcon from '@mui/icons-material/Settings';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import VideoLabelIcon from '@mui/icons-material/VideoLabel';
import StepConnector from '@mui/material/StepConnector';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Config from '../../../tutorial-pages/config';
import Address from '../../../tutorial-pages/address';
import Sla from '../../../tutorial-pages/sla';
import Categories from '../../../tutorial-pages/categories';
import User from '../../../tutorial-pages/user';
import Organization from '../../../tutorial-pages/select-organization';
import Team from '../../../tutorial-pages/team';
import { Link } from 'react-router-dom';

const Steps = withStyles({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  active: {
    '& $line': {
      borderColor: '#784af4',
    },
  },
  completed: {
    '& $line': {
      borderColor: '#784af4',
    },
  },
  line: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
})(StepConnector);

const useQontoStepIconStyles = makeStyles({
  root: {
    color: '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center',
  },
  active: {
    color: '#784af4',
  },
  circle: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
  completed: {
    color: '#784af4',
    zIndex: 1,
    fontSize: 18,
  },
});

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? <Check className={classes.completed} /> : <div className={classes.circle} />}
    </div>
  );
}

QontoStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
};

const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 22,
  },
  active: {
    '& $line': {
      backgroundImage:
        'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
    },
  },
  completed: {
    '& $line': {
      backgroundImage:
        'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1,
  },
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  active: {
    backgroundImage:
      'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  },
  completed: {
    backgroundImage:
      'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
  },
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: <SettingsIcon />,
    2: <GroupAddIcon />,
    3: <VideoLabelIcon />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

function getSteps() {
  const intl = this.props.intl;
  return [intl.formatMessage({id:"tutorial.progress.steps.select.organization"}), intl.formatMessage({id:"config"}), intl.formatMessage({id:"address"}), intl.formatMessage({id:"slas"}), intl.formatMessage({id:"menu.categories"}), intl.formatMessage({id:"menu.users"}), intl.formatMessage({id:"attendance.team"}), intl.formatMessage({id:"ready"})];
}

function getStepContent(step) {
  const intl = this.props.intl;
  switch (step) {
    case 0:
      return intl.formatMessage({id:"tutorial.progress.steps.select.organization"});
    case 1:
      return intl.formatMessage({id:"tutorial.progress.steps.config.organization"});
    case 2:
      return intl.formatMessage({id:"tutorial.progress.steps.register.address"});
    case 3:
      return intl.formatMessage({id:"tutorial.progress.steps.create.slas"});
    case 4:
      return intl.formatMessage({id:"tutorial.progress.steps.associate.categories"});
    case 5:
      return intl.formatMessage({id:"tutorial.progress.steps.create.technician"});
    case 6:
      return intl.formatMessage({id:"tutorial.progress.steps.create.attendance.team"});
    default:
      return intl.formatMessage({id:"tutorial.progress.steps.complete"});
  }
}

function getContent(step, save, organizationid, handleBack, handleNext, handleReset, orgId) {
  const intl = this.props.intl;
  switch (step) {
    case 0:
      return <Organization save={save} orgId={orgId} next={handleNext}/> ;
    case 1:
      return <Config organizationid={organizationid} back={handleBack} next={handleNext} />;
    case 2:
      return <Address organizationid={organizationid} back={handleBack} next={handleNext} />;
    case 3:
      return <Sla organizationid={organizationid} back={handleBack} next={handleNext} />;
    case 4:
      return <Categories organizationid={organizationid} back={handleBack} next={handleNext} />;
    case 5:
      return <User organizationid={organizationid} back={handleBack} next={handleNext} />;
    case 6:
      return <Team organizationid={organizationid} back={handleBack} next={handleNext} />;
    default:
      return <div>
              <Button
                variant="contained"
                color="primary"
                component={Link} {...{ to: `/pt/calleds` }}
                >
                {intl.formatMessage({id:"end"})}
              </Button>
            </div>;
  }
}

const CustomizedSteppers = props => {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();
  const intl = this.props.intl;

  const save = (organizationid) => {
    props.save(organizationid);
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    props.attNotification();
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    props.reset();
  };

  return (
    <div className={classes.root}>
      <Stepper alternativeLabel activeStep={activeStep}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))} 
      </Stepper>
      <div>
        {activeStep === steps.length ? (
          <div>
            <Typography className={classes.instructions}>
              {intl.formatMessage({id:"tutorial.progress.typography.tutorial.complete"})}
            </Typography>
            <Button
                  variant="contained"
                  color="primary"
                  onClick={handleReset}
                  className={classes.button}
                >
                  {intl.formatMessage({id:"end"})}
              </Button>
          </div>
        ) : (
          <div>
            <Typography>{getStepContent(activeStep)}</Typography>
            {getContent(activeStep, save, props.organization, handleBack, handleNext, handleReset, props.orgId )}
            
            {/* {activeStep == 0 && (
              <div>
                <Button disabled={activeStep === 0} onClick={handleBack} className={classes.button}>
                  Voltar
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleNext}
                  className={classes.button}
                >
                  {activeStep === steps.length - 1 ? 'Finalizar' : 'Próximo'}
                </Button>
              </div>
            )} */}
          </div>
        )}
      </div>
    </div>
  );
}

CustomizedSteppers.propTypes = {
  save: PropTypes.func,
  organization: PropTypes.string,
  reset: PropTypes.func,
  orgId: PropTypes.string,
  attNotification: PropTypes.func
};

export default CustomizedSteppers;
